import React, { useContext, useEffect, useState } from 'react';
import Verify from '../common/Verify';
import { AuthContext } from '../../../Context/authContext';
import { requestForOTP, verifyOTP } from '../api';
import { useNavigate, useLocation } from 'react-router-dom';
import routes from '../../../Constants/routes';
import validator from 'validator';
import KenLoader from '../../../Components/KenLoader';
import { useSnackbar } from 'notistack';
import { handleError } from '../util';
import AuthLayout from '../AuthLayout';

export default function LoginOTP(props) {
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const { state: navigateState } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [isEmail, setIsEmail] = useState(null);
  const [otp, setOtp] = useState('');

  useEffect(() => {
    if (!navigateState?.id) {
      navigate(routes.login);
    } else {
      setIsEmail(validator.isEmail(navigateState.currentId));
    }
  }, [navigate, navigateState?.currentId, navigateState?.id]);

  const onSubmit = async ({ otp: { otp } }) => {
    setLoading(true);
    try {
      const res = await verifyOTP({
        otp,
        id: navigateState.currentId,
      });

      if (!res || !res?.success) {
        setOtp(null);
        return enqueueSnackbar(res?.errorMessage || 'Something went wrong', {
          variant: 'error',
        });
      }
      const data = {
        id: navigateState.id,
        applicantEmail: res?.applicantEmail,
        applicantId: res?.applicantId,
        applicantName: res?.applicantName,
        applicantDob: res?.applicantDob,
        accessToken: {
          accessToken: res?.accessToken,
        },
        refreshToken: {
          refreshToken: res?.refreshToken,
        },
      };
      // TODO: load token
      dispatch({
        type: 'LOGIN',
        payload: {
          user: data,
        },
      });
    } catch (error) {
      setOtp(null);
      handleError(enqueueSnackbar, error);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    const res = await requestForOTP({
      id: navigateState.currentId,
    });

    return res;
  };

  return (
    <>
      {typeof isEmail !== 'boolean' ? (
        <KenLoader />
      ) : (
        <>
          {loading && <KenLoader />}
          <AuthLayout>
            <Verify
              loading={loading}
              from="loginOTP"
              title={
                <>
                  <span>Verify OTP</span>
                </>
              }
              subTitle={
                <>
                  <span>
                    {isEmail
                      ? 'Please enter the OTP sent to your registered Email ID.'
                      : 'Please entre the OTP sent on your registered mobile number'}
                  </span>
                  {!isEmail && (
                    <strong style={{ marginLeft: '5px' }}>
                      *******{navigateState.currentId.slice(-3)}.
                    </strong>
                  )}
                </>
              }
              submitText="Verify & Log In"
              onVerify={(otp) => {
                onSubmit({ otp });
              }}
              handleResendOtp={handleResendOtp}
              otp={otp}
              setOtp={setOtp}
            />
          </AuthLayout>
        </>
      )}
    </>
  );
}
